import { useTranslation } from 'react-i18next';

import { FormFieldCombobox } from '~/components/FormField';
import { useLabelGroupList } from '~/modules/settings/api/queries/labelGroupList';
import { RoleMap } from '~/modules/settings/constants/RoleMap';

type InternalPermissionsProps = {
  name: string;
};

const INTERNAL_USER_ROLES = [
  'OPS_ADMIN',
  'TECH_ADMIN',
  'RELEASE_MANAGER',
  'RELEASE_COORDINATOR',
  'VIDEO_MANAGER',
  'SUPPORT_ADMIN',
] as const;

const mapRoles = (
  roles: Readonly<Array<keyof typeof RoleMap>>,
  t: (key: string) => string,
) =>
  roles.map((role) => ({
    value: role,
    label: t(RoleMap[role].name),
  }));

export const InternalPermissions = ({ name }: InternalPermissionsProps) => {
  const { labelGroupList } = useLabelGroupList({});

  const { t: rolesT } = useTranslation('settings', { keyPrefix: 'roles' });
  const { t } = useTranslation('settings', { keyPrefix: 'user' });

  const labelGroups = labelGroupList?.data ?? [];

  return (
    <div className="grid grid-cols-3 items-start gap-md">
      <FormFieldCombobox
        name={`${name}.roles`}
        label={t('fields.role')}
        multiselect
        displaySelectedOptions
        options={mapRoles(INTERNAL_USER_ROLES, rolesT)}
      />
      <FormFieldCombobox
        name={`${name}.labelGroups`}
        label={t('fields.labels')}
        multiselect
        displaySelectedOptions
        options={labelGroups.map((labelGroup) => ({
          label: labelGroup.name,
          value: labelGroup.id,
        }))}
      />
    </div>
  );
};

InternalPermissions.displayName = 'InternalPermissions';
